import { FC } from 'react';
import Button, { ButtonSizes, ButtonVariants } from '@/components/new-design/Button';
import usdt from '@/assets/profile/tether.svg';
import styles from './RebuyButton.module.css';
import buttonStyles from '@/components/new-design/Button.module.css';
import { LobbyTableOpenBuyInAction } from '@/services/lobby/lobbyActions';
import { useDispatch } from 'react-redux';
import WalletIcon from '@/components/WalletIcon';
import config from '@/common/config';
import { useWalletAddress } from '@/features/account-abstraction/hooks/useWalletAddress';
import useIsMobileView from '@/hooks/useIsMobileView';
import useWalletBalance from '@/hooks/useWalletBalance';
import { twMerge } from 'tailwind-merge';

interface RebuyButtonProps {
  tableId: string;
  seat?: number | null;
}
const RebuyButton: FC<RebuyButtonProps> = ({ tableId, seat }) => {
  // TODO handle loading state of the rebuy modal to show a loader on the
  // button when waiting for transactions to finish.
  const dispatch = useDispatch();

  const buttonDisabled = !tableId || seat === undefined || seat === null;

  const isMobileView = useIsMobileView();
  const handleOnClickRebuy = () => {
    if (!buttonDisabled) {
      dispatch(LobbyTableOpenBuyInAction(tableId, seat, 0, true, true, false));
    }
  };
  const { walletAddress } = useWalletAddress();
  const { data } = useWalletBalance(walletAddress, config.contracts.usdt);

  if (isMobileView) {
    return (
      <div>
        <WalletIcon className="h-6 w-6 text-ph-gray-silver hover:text-ph-gray-white" onClick={handleOnClickRebuy} />
      </div>
    );
  }

  return (
    <div className="flex w-full justify-center gap-2">
      <Button
        disabled={buttonDisabled}
        onClick={handleOnClickRebuy}
        size={ButtonSizes.xl}
        variant={ButtonVariants.transparentWithBorder}
        className={twMerge(styles.button, buttonStyles.pillWithBorder)}
      >
        <WalletIcon className={styles.icon} />
        {data?.displayBalance || '-'}
        <img src={usdt} alt="usdt" className="h-6 w-6 min-w-6" />
      </Button>
    </div>
  );
};

export default RebuyButton;
